import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import getProductDict from '../../customer/system/productDict';
import LayoutRadioGroup from 'components/forms/LayoutRadioGroup';
import LayoutSelect from 'components/forms/layoutSelect';
import Loader from 'components/loader';
import LoadingBtn from 'components/loadingBtn';
import Pool from 'models/pool';
import ProductApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import session from 'services/sessionService';
import WaterEnhancerApi from 'api/waterEnhancer';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {
  systemTypeNamesFormat,
  systemTypes,
  productTypes,
  poolProductTypeNamesFormat,
  spaProductTypeNamesFormat,
  swimSpaProductTypeNamesFormat,
  waterEnhancersPerSystem,
} from 'helpers/constants';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

const ALL = {value: 'All', label: 'All'};

function getProductCount(branchSummaries, productCode) {
  let product = branchSummaries.find(x => x.product === productCode);

  if (product) {
    return product.count;
  }
  return 0;
}

function getWaterEnhancerCount(branchSummaries, waterEnhancer, currentStatusSelected, replaceStatusSelected) {
  if (!(branchSummaries && currentStatusSelected !== replaceStatusSelected)) {
    return 0;
  }

  let enhancer = branchSummaries.find(x => x.enhancer === waterEnhancer);

  return currentStatusSelected ? enhancer.countEnabled : enhancer.countDisabled;
}


function getProductName(names, ids, product) {
  for (let i = 0; i < ids.length; ++i) {
    if (product === ids[i]) {
      return names[i];
    }
  }
  return '';
}

class ProductUpdate extends React.PureComponent {
  static displayName = 'ProductUpdate';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    branchSummaries: [],
    branches: [],
    dealer: {},
    loaded: false,
    products: [],
    productType: '',
    saving: false,
    selectedBranches: [],
    systemType: 1,
    currentProduct: null,
    currentProductCode: null,
    currentWaterEnhancerStatus: null,
    replacementWaterEnhancerStatus: null,
    replacementProduct: null,
    systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
    currentWaterEnhancer: null,
    isWaterEnhancerProduct: false,
  };

  componentWillMount() {
    const {formatMessage} = this.props.intl;

    this.fetchData();

    ALL.label = formatMessage({id: 'general.all'});
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }


  fetchData = () => {
    let apis = [];

    apis.push(BranchApi.getFullBranches());
    apis.push(ProductApi.getProducts());
    apis.push(DealerApi.getDealer(session.getUser().dealerId));

    Promise.all(apis)
      .then(([branches, products, dealer]) => {
        let selectedBranches = [];

        if (branches.length === 1) {
          selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
        }
        this.setState({
          branches,
          dealer,
          loaded: true,
          products,
          selectedBranches,
        });
      });
  };

  switchBranch = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      this.setState({
        branchSummaries: [],
        currentProduct: null,
        currentProductCode: null,
        productType: '',
        currentWaterEnhancerStatus: null,
        replacementWaterEnhancerStatus: null,
        replacementProduct: null,
        selectedBranches: [],
        systemType: 1,
        systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
        currentWaterEnhancer: null,
        isWaterEnhancerProduct: false,
      });
      return;
    }
    // Ensure that 'All' cannot be selected along with other values in a multiselect
    if (Array.isArray(selectedOptions) && Array.isArray(this.state.selectedBranches)) {
      let prevIndexOfAll = this.state.selectedBranches.indexOf(ALL);
      let currentIdxOfAll = selectedOptions.indexOf(ALL);

      // If 'ALL' is being added to the selected options, then force it to be the only option selected
      if (currentIdxOfAll !== -1 && prevIndexOfAll === -1) {
        selectedOptions = [selectedOptions[currentIdxOfAll]];
        // Remove 'ALL', when the user is trying to add another option
      } else if (currentIdxOfAll !== -1 && selectedOptions.length > 1) {
        selectedOptions.splice(currentIdxOfAll, 1);
      }
    }

    this.setState({
      branchSummaries: [],
      currentProduct: null,
      currentProductCode: null,
      productType: '',
      replacementProduct: null,
      selectedBranches: selectedOptions,
      systemType: 1,
      systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
      currentWaterEnhancerStatus: null,
      replacementWaterEnhancerStatus: null,
      currentWaterEnhancer: null,
      isWaterEnhancerProduct: false,
    });
  };

  switchProductCategory = (e) => {
    let {formatMessage} = this.props.intl;

    if (e && e.value) {
      if (e.value !== 'waterenhancers') {
        this.setState({loaded: false});
        let branchIDs = this.state.selectedBranches.map(x => x.value).join(',');

        if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
          branchIDs = this.state.branches.map(x => x.id).join(',');
        }
        ProductApi.getBranchSummaries(branchIDs, this.state.systemType, parseInt(e.value))
          .then(branchSummaries => {
            this.setState({
              branchSummaries,
              currentProduct: null,
              currentProductCode: null,
              loaded: true,
              productType: parseInt(e.value),
              replacementProduct: null,
              currentWaterEnhancer: null,
              isWaterEnhancerProduct: false,
              currentWaterEnhancerStatus: null,
              replacementWaterEnhancerStatus: null,
            });
          }).catch(e => {
            console.log(e);
            this.setState({loaded: true});
          });
      } else {
        this.setState({
          loaded: true,
          currentProduct: null,
          currentProductCode: null,
          productType: e.value,
          replacementProduct: null,
          branchSummaries: [],
          currentWaterEnhancerStatus: true,
          replacementWaterEnhancerStatus: false,
          isWaterEnhancerProduct: true,
        });
      }

    } else {
      this.setState({
        branchSummaries: [],
        productType: e.value,
        currentProduct: null,
        currentProductCode: null,
        replacementProduct: null,
        currentWaterEnhancer: null,
        isWaterEnhancerProduct: false,
      });
    }
  };

  switchSelectedWaterEnhancer = (e) => {
    let {formatMessage} = this.props.intl;

    if (e.value) {
      this.setState({loaded: false});
      let branchIDs = this.state.selectedBranches.map(x => x.value).join(',');

      if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
        branchIDs = this.state.branches.map(x => x.id).join(',');
      }

      WaterEnhancerApi.getBranchEnhancerSummaries(branchIDs, this.state.systemType, e.value)
        .then(branchSummaries => {
          this.setState({
            branchSummaries,
            loaded: true,
            [e.key]: e.value,
          });
        }).catch(e => {
          console.log(e);
          this.setState({loaded: true});
        });
    } else {
      this.setState({
        [e.key]: null,
      });
    }
  };

  switchWaterEnhancerStatus = (e) => {
    this.setState({
      [e.key]: e.value === 'true',
    });
  };


  getProductTypeOptions = (typeID) => {
    if (typeID === systemTypes.spa) {
      return spaProductTypeNamesFormat(this.props.intl.formatMessage);
    } else if (typeID === systemTypes.swimspa) {
      return swimSpaProductTypeNamesFormat(this.props.intl.formatMessage);
    }
    return poolProductTypeNamesFormat(this.props.intl.formatMessage);
  };

  switchSystemType = (e) => {
    this.setState({
      branchSummaries: [],
      currentProduct: null,
      currentProductCode: null,
      currentWaterEnhancer: null,
      isWaterEnhancerProduct: false,
      productType: '',
      replacementProduct: null,
      systemType: parseInt(e.value),
      systemProductTypes: this.getProductTypeOptions(parseInt(e.value)),
      currentWaterEnhancerStatus: null,
      replacementWaterEnhancerStatus: null,
    });
  };

  updateProduct = (productsDict) => (e) => {
    let state = Object.assign({}, this.state);

    if (e.value) {
      state[e.key] = e.value;
    } else {
      state[e.key] = null;
    }

    if (e.key === 'currentProduct') {
      state.currentProductCode = e.value ? productsDict.products.find(p => p.id === e.value).wardenID : null;
    }

    this.setState(state);
  };

  cancel = () => {
    location.hash = '#tools/accounts';
  };

  submitEnabled = () => {
    let {
      saving, selectedBranches, systemType, productType, currentProduct, currentProductCode, replacementProduct, branchSummaries,
      isWaterEnhancerProduct, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus,
    } = this.state;

    let productChangeCondition = currentProduct && currentProductCode && replacementProduct && currentProduct !== replacementProduct &&
      branchSummaries.length > 0 && branchSummaries.find(x => x.product === currentProductCode && !isWaterEnhancerProduct);

    let waterEnhancerChangeCondition = isWaterEnhancerProduct && currentWaterEnhancer && currentWaterEnhancerStatus !== replacementWaterEnhancerStatus;

    return !saving && selectedBranches.length && systemType && productType && (productChangeCondition || waterEnhancerChangeCondition);
  };

  submit = () => {
    let {formatMessage} = this.props.intl;
    let {
      branches, selectedBranches, systemType, productType, currentProduct, currentProductCode, replacementProduct, branchSummaries,
      isWaterEnhancerProduct, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus,
    } = this.state;

    if (this.submitEnabled()) {
      this.setState({saving: true});

      let branchIDs = selectedBranches.map(x => x.value).join(',');

      if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
        branchIDs = this.state.branches.map(x => x.id).join(',');
      }
      if (!isWaterEnhancerProduct) {
        let num = getProductCount(branchSummaries, currentProductCode);

        let pool = new Pool({typeID: systemType});
        let {productDict} = getProductDict({pool, products: this.state.products, dealer: this.state.dealer, formatMessage});
        let {keys, names} = productDict[Object.keys(productTypes).find(x => productTypes[x] === productType)];

        let {productDict: fullDict} = getProductDict({
          pool,
          products: this.state.products,
          dealer: this.state.dealer,
          prevPool: pool,
          noFilter: true,
          formatMessage,
        });
        let {names: fullNames, keys: fullKeys} = fullDict[Object.keys(productTypes).find(x => productTypes[x] === productType)];

        let currentProductName = getProductName(fullNames, fullKeys, currentProduct);
        let newProductName = getProductName(names, keys, replacementProduct);

        ProductApi
          .updateProducts(branchIDs, systemType, productType, currentProduct, replacementProduct)
          .then(() => {
            events.publish('success.user', {
              message: formatMessage({id: 'tools.update.products.successfully'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
            });
            if (this.mounted) {
              let selectedBranches = [];

              if (branches.length === 1) {
                selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
              }

              this.setState({
                branchSummaries: [],
                productType: '',
                saving: false,
                selectedBranches,
                systemType: 1,
                currentProduct: null,
                currentProductCode: null,
                replacementProduct: null,
                currentWaterEnhancerStatus: null,
                replacementWaterEnhancerStatus: null,
                currentWaterEnhancer: null,
                isWaterEnhancerProduct: false,
              });
            }
          })
          .catch(err => {
            console.error(err);
            events.publish('error.user', {
              message: formatMessage({id: 'tools.update.products.failed'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
            });
          });
      } else {
        let num = getWaterEnhancerCount(branchSummaries, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus);
        let waterEnhancers = waterEnhancersPerSystem(this.state.systemType, formatMessage);
        let enhancer = waterEnhancers[currentWaterEnhancer];

        WaterEnhancerApi.updateWaterEnhancers(branchIDs, systemType, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus)
          .then(() => {
            events.publish('success.user', {
              message: formatMessage({id: 'tools.update.enhancers.successfully'},
                {enhancer, count: num,
                  currentstatus: currentWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                  newstatus: replacementWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                }),
            });
            if (this.mounted) {
              let selectedBranches = [];

              if (branches.length === 1) {
                selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
              }

              this.setState({
                branchSummaries: [],
                productType: '',
                saving: false,
                selectedBranches,
                systemType: 1,
                currentProduct: null,
                currentProductCode: null,
                replacementProduct: null,
                currentWaterEnhancerStatus: null,
                replacementWaterEnhancerStatus: null,
                currentWaterEnhancer: null,
                isWaterEnhancerProduct: false,
              });
            }
          })
          .catch(err => {
            console.error(err);
            events.publish('error.user', {
              message: formatMessage({id: 'tools.update.enhancers.failed'},
                {enhancer, count: num,
                  currentstatus: currentWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                  newstatus: replacementWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                }),
            });
          });
      }
    }
  };

  getStepOne = () => {
    let branchOptions = [ALL].concat(this.state.branches.map(({id, name}) => ({label: name, value: id})));
    let {formatMessage} = this.props.intl;

    return <div className='col-md-4'>
      <Step number={1}
            total={3}
            title={formatMessage({id: 'general.select.store'}) + '(s)'}>
        <div>
          {branchOptions.length > 2 ? // This should be 2 since all is included as an option
            <ReactSelect name='branches'
                         multi={true}
                         options={branchOptions}
                         value={this.state.selectedBranches}
                         placeholder={this.props.intl.formatMessage({id: 'general.select.store'})}
                         onChange={this.switchBranch}/> :
            this.state.selectedBranches.length > 0 ? this.state.selectedBranches[0].label : null
          }
        </div>
      </Step>
    </div>;
  };

  getStepTwo = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.selectedBranches.length) {
      return null;
    }
    let systemProductTypes = poolProductTypeNamesFormat(this.props.intl.formatMessage);
    let productTypeKeys = Object.keys(systemProductTypes);
    let productTypeOptions = Object.values(systemProductTypes);

    //Default empty option
    productTypeKeys.unshift('');
    productTypeOptions.unshift(formatMessage({id: 'tools.update.select.type'}));
    //Water Enhancer option
    productTypeKeys.push('waterenhancers');
    productTypeOptions.push(formatMessage({id: 'chemicals.water.enhancers'}));

    const systemTypeNames = systemTypeNamesFormat(formatMessage);
    let systemTypeKeys = Object.keys(systemTypeNames).map(x => parseInt(x));
    let systemTypeOptions = Object.values(systemTypeNames);

    return <div className='col-md-4'>
      <Step number={2}
            total={3}
            title={formatMessage({id: 'tools.update.system.product'})}>
        <div>
          <LayoutRadioGroup label={formatMessage({id: 'general.system.type'})}
                            options={systemTypeOptions}
                            dataKey='systemType'
                            inline={true}
                            colSizes={[4, 3, 5]}
                            value={this.state.systemType}
                            keys={systemTypeKeys}
                            onChange={this.switchSystemType}/>
          <LayoutSelect label={formatMessage({id: 'general.product.category'})}
                        editMode={true}
                        keys={productTypeKeys}
                        options={productTypeOptions}
                        dataKey='productType'
                        dataChanged={this.switchProductCategory}
                        value={this.state.productType}/>
        </div>
      </Step>
    </div>;
  };

  getStepThree = () => {
    if (this.state.isWaterEnhancerProduct) {
      return this.getStepThreeWaterEnhancers();
    }
    return this.getStepThreeProductDetails();
  };
  getStepThreeProductDetails = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.productType || !this.state.systemType) {
      return null;
    }

    const pool = new Pool({typeID: this.state.systemType});
    let {productDict} = getProductDict({pool, products: this.state.products, dealer: this.state.dealer, formatMessage});
    let {productDict: fullDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      prevPool: pool,
      noFilter: true,
      formatMessage,
    });

    let prodType = Object.keys(productTypes).find(x => productTypes[x] === this.state.productType);
    let {names, keys} = productDict[prodType];
    let {names: fullNames, keys: fullKeys} = fullDict[prodType];

    if (names.length === 0) {
      names.push('n/a');
      keys.push('');
    } else {
      names.unshift(formatMessage({id: 'tools.update.select.product'}));
      keys.unshift('');
    }

    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');
    }

    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.recommended'})}>
        <div>
          <LayoutSelect label={formatMessage({id: 'tools.update.current.product'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentProduct || ''}
                        dataKey='currentProduct'
                        dataChanged={this.updateProduct(fullDict[prodType])}
                        editMode={true}/>
          <LayoutSelect label={formatMessage({id: 'tools.replace.with'})}
                        dataKey='replacementProduct'
                        options={names}
                        keys={keys}
                        value={this.state.replacementProduct || ''}
                        dataChanged={this.updateProduct(productDict[prodType])}
                        editMode={true}/>
        </div>
      </Step>
    </div>;
  };

  getStepThreeWaterEnhancers = () => {
    if (!this.state.systemType) {
      return null;
    }
    let {formatMessage} = this.props.intl;
    let waterEnhancers =   waterEnhancersPerSystem(this.state.systemType, this.props.intl.formatMessage);
    let fullKeys =  Object.keys(waterEnhancers);
    let fullNames =  Object.values(waterEnhancers);

    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');
    }

    let waterEnhancerStatus = {
      names: [formatMessage({id: 'tools.update.enhancer.checked'}), formatMessage({id: 'tools.update.enhancer.unchecked'})],
      keys: ['true', 'false'],
    };

    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.enhancer'})}>
        <div>
          <LayoutSelect label={formatMessage({id: 'tools.update.select.enhancer'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentWaterEnhancer}
                        dataKey='currentWaterEnhancer'
                        dataChanged={this.switchSelectedWaterEnhancer}
                        editMode={true}/>
          <LayoutRadioGroup label={formatMessage({id: 'tools.update.current.status'})}
                            options={waterEnhancerStatus.names}
                            dataKey='currentWaterEnhancerStatus'
                            groupName='currentWaterEnhancerStatus'
                            inline={true}
                            value={this.state.currentWaterEnhancerStatus.toString()}
                            keys={waterEnhancerStatus.keys}
                            onChange={this.switchWaterEnhancerStatus}/>
          <LayoutRadioGroup label={formatMessage({id: 'tools.update.replace.status'})}
                            options={waterEnhancerStatus.names}
                            dataKey='replacementWaterEnhancerStatus'
                            groupName='replacementWaterEnhancerStatus'
                            inline={true}
                            value={this.state.replacementWaterEnhancerStatus.toString()}
                            keys={waterEnhancerStatus.keys}
                            onChange={this.switchWaterEnhancerStatus}/>
        </div>
      </Step>
    </div>;
  };

  render() {
    return <div className='product-update-tool'>
      <h2><FormattedMessage id="tools.update.product.profile"/></h2>
      <p><FormattedMessage id="tools.update.product.explanation"/></p>
      <Loader loaded={this.state.loaded}>
        <div className='col-xs-12'>
          <div className='row product-step-row'>
            {this.getStepOne()}
            {this.getStepTwo()}
            {this.getStepThree()}
          </div>
        </div>
        <div className='row'>
          {this.state.branchSummaries.length > 0 && (this.state.currentProduct || this.state.currentWaterEnhancer) ?
            <div className='col-xs-12 disclaimer'>
              <i className='bl bl-help-circle blue'/>&nbsp;&nbsp;
              <FormattedMessage id="tools.update.systems.count" values={{count: this.state.currentProduct ?
                getProductCount(this.state.branchSummaries, this.state.currentProductCode) :
                getWaterEnhancerCount(this.state.branchSummaries, this.state.currentWaterEnhancer,
                  this.state.currentWaterEnhancerStatus, this.state.replacementWaterEnhancerStatus)}}/>
              <span className='blue semi-bold'> <FormattedMessage id="tools.update.cannot.undone"/></span>
            </div> : null}
          <div className='col-xs-12'>
            <div className='pull-right'>
              <button className='btn btn-default'
                      style={{marginRight: 15}}
                      onClick={this.cancel}><FormattedMessage id="general.cancel"/></button>
              <LoadingBtn className='btn btn-primary'
                          onClick={this.submit}
                          disabled={!this.submitEnabled()}
                          loading={this.state.saving}><FormattedMessage id="general.update"/></LoadingBtn>
            </div>
          </div>
        </div>
      </Loader>
    </div>;
  }
}

class Step extends React.PureComponent {
  static displayName = 'Step';

  static propTypes = {
    children: PropTypes.element.isRequired,
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
  };

  render() {
    return <div className='product-update-step'>
      <p className='step-label'>
        <FormattedMessage id='general.step.range'
                          values={{
                            n: this.props.number,
                            total: this.props.total,
                          }} />
      </p>
      <h3>{this.props.title}</h3>
      {this.props.children}
    </div>;
  }
}

export default bindLocaleUpdate(injectIntl(ProductUpdate));
